export const CERTIFICATES_ERRORS = {
  "certificate.wrong": "Номер сертификата или пин-код указаны неверно",
  "certificate.duplicate": "Сертификат уже был введен ранее",
  "certificate.activated": "Сертификат уже был использован",
};
